
import * as filterHeaderTypes from '../../webcommon/header/filterheader/propTypes';
import { lastWorkingDay } from '../../common/helpermethods/HelperMethods';

export const fileAvailabilityColumns = [
    // {   
    //     Header: 'Id',
    //     id : 'id'
    // }, 
    {   
        Header: 'FileName',
        id : 'fileName'
    },
    {   
        Header: 'RunDate',
        id : 'runDate'
    },
    {
        Header: 'Status',
        id: 'status'
    }
]

export const filterDefinitions = [
    {
        id: 'runDate',
        title: 'Date',
        type: filterHeaderTypes.filterTypes.date,
        defaultValue: { from: lastWorkingDay(), to: lastWorkingDay(), today: false },
        availableValues: undefined,
        availableValuesLocation: undefined,
        server: true,
        useValidation: true,
        hideAllButton: true,
        hideToday: true
    }
]
export const defaultFilters = [
    {
        value: {
            from: lastWorkingDay(),
            to: lastWorkingDay(),
            today: false
        },
        definition: filterDefinitions.find(def => def.id === 'runDate')
    }
]